package com.appsyde.shared.modules.team.domain.usecase

import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class DisableUserUseCase(
    private val repository: TeamRepository
) {
    suspend operator fun invoke(userId: String): Boolean =
        repository.disableUser(userId)
}
